import { render } from "./BaseNavigation.vue?vue&type=template&id=8ce8084a&scoped=true&ts=true"
import script from "./BaseNavigation.vue?vue&type=script&lang=ts"
export * from "./BaseNavigation.vue?vue&type=script&lang=ts"

import "./BaseNavigation.vue?vue&type=style&index=0&id=8ce8084a&lang=scss&scoped=true"

import exportComponent from "/builds/atx/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8ce8084a"]])

export default __exports__